import { Form, Input, Checkbox } from 'antd';

export const SInput = Input;

export const SFormItem = Form.Item;

export const SCheckbox = Checkbox;
